import type { Maybe } from '@tenable/paladin'

/**
 * Parse the version to retrieve the major and minor values.
 * Everything after the minor number will be ignored, so v3.93.0-alpha4 will return:
 * { major: 3, minor: 93 }
 */
export function getMajorMinorNumbersFromVersion(
  version: string
): Maybe<{ major: number; minor: number }> {
  const versionMatch = version.match(/^v(?<major>\d+)\.(?<minor>\d+)/)

  if (!versionMatch || !versionMatch.groups) {
    return null
  }

  const { major, minor } = versionMatch.groups

  const majorNumber = Number(major)
  const minorNumber = Number(minor)

  if (Number.isNaN(majorNumber) || Number.isNaN(minorNumber)) {
    return null
  }

  return {
    major: majorNumber,
    minor: minorNumber
  }
}
